import { Box } from "@mui/material";
import { QuestionnaireEvaluation } from "Components/Analyses/Questionnaire/QuestionnaireEvaluation";
import { PdfQuestionnaireBoundary } from "./PdfQuestionnaireBoundary";
import { PdfQuestionnaireForm } from "./PdfQuestionnaireForm";

export const PdfQuestionnaireEvaluation = () => (
  <PdfQuestionnaireBoundary>
    {(data) => (
      <>
        <PdfQuestionnaireForm initialAnswerItems={(data.questionnaireAnswers ?? []).flatMap((qa) => qa.questionnaireAnswerItems ?? [])} />
        <Box sx={{ breakBefore: "page" }}>
          <QuestionnaireEvaluation status={data.status} onReEvaluate={() => {}} onShowQuestionnaire={() => {}} onChangeAnswers={() => {}} />
        </Box>
      </>
    )}
  </PdfQuestionnaireBoundary>
);
